<template>
  <div
    v-if="show"
    class="absolute top-[calc(100%+12px)] left-0 z-[50] w-[320px] rounded-[16px] border border-[rgba(11,18,40,0.1)] bg-white p-[16px] shadow-[0_18px_50px_rgba(8,19,62,0.12)]"
    @click.stop
  >
    <div class="flex items-center rounded-[12px] border border-[rgba(11,18,40,0.1)] px-[12px] py-[10px]">
      <input
        v-model.trim="keyword"
        type="text"
        class="w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#8c8f97]"
        :placeholder="t('83088')"
      />
    </div>

    <div class="mt-[12px] overflow-y-auto" :class="compact ? 'max-h-[132px]' : 'max-h-[280px]'">
      <button
        v-for="country in filteredCountries"
        :key="`${country.twoCharCode}-${country.code}`"
        type="button"
        class="flex w-full cursor-pointer items-center gap-[12px] rounded-[12px] px-[8px] py-[10px] text-left hover:bg-[#f6f8fb]"
        @click="selectCountry(country)"
      >
        <CommonImage :src="country.flag" :alt="country.name" class="h-[18px] w-[28px] rounded-[3px] object-cover" />
        <span class="w-[52px] shrink-0 text-[14px] leading-[22px] text-[#292a2e]">{{ country.code }}</span>
        <span class="min-w-0 flex-1 truncate text-[14px] leading-[22px] text-[#4d5562]">{{ country.name }}</span>
      </button>

      <p v-if="filteredCountries.length === 0" class="px-[8px] py-[16px] text-[13px] leading-[20px] text-[#8c8f97]">
        {{ t('84067') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LoginCountry } from '~/composables/useLoginCountries'

defineProps<{
  show: boolean
  compact?: boolean
}>()

const emit = defineEmits<{
  select: [country: LoginCountry]
}>()

const { t } = useAppI18n()
const matomo = useMatomo()
const keyword = ref('')
const { flatCountries } = useLoginCountries()

const filteredCountries = computed(() => {
  if (!keyword.value) {
    return flatCountries.value
  }

  const normalizedKeyword = keyword.value.toLowerCase()
  return flatCountries.value.filter((item) => {
    return (
      item.name.toLowerCase().includes(normalizedKeyword) ||
      item.code.toLowerCase().includes(normalizedKeyword) ||
      item.twoCharCode.toLowerCase().includes(normalizedKeyword)
    )
  })
})

const selectCountry = (country: LoginCountry) => {
  keyword.value = ''
  emit('select', country)
  matomo.trackEvent('af_phone_country', {
    af_content: country.code,
  })
}
</script>
